import headerTar from "../pages/home/components/header";
import footerTar from "../pages/home/components/footer";
import { listenWindowMixins } from '../mixin/listenWindow'
export default {
  name: "App",
  mixins: [listenWindowMixins],
  data () {
    return {
      clientWidth: true
    }
  },
  watch: {},
  methods: {
  },
  components: {
    headerTar,
    footerTar
  },
  computed: {},
  mounted: function () {
    this.clientWidth = window.innerWidth > 1000
  }
}



// WEBPACK FOOTER //
// ./src/pages/app.js